import "@wwg/ui/dist/index.css";
import "./index.css";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { App } from "./App";
import { Auth, LoginGuard } from "./shared/auth";
import { QueryParams } from "shared/hooks/useQueryParams";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";
import ReactModal from "react-modal";

import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import Cookies from "js-cookie";

var language = Cookies.get("language-code") || "en";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: require("./locales/en/translation.json"),
      },
      es: {
        translation: require("./locales/es/translation.json"),
      },
    },
    lng: language,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    pluralSeparator: "_",
  });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /**
       * Use makeAuthedRequest as default query function.
       */
      async queryFn({ queryKey }) {
        return makeAuthedRequest(queryKey).then(async (res) => {
          const json = await res.json();

          if (res.ok) {
            return json.data;
          } else {
            console.error(json);
            throw new Error(`Request failed`);
          }
        });
      },

      staleTime: 1000 * 60 * 20, // 20 minutes
      // refetchOnMount: false,
    },
  },
});

const $root = document.getElementById("root");

ReactModal.setAppElement($root);

ReactDOM.render(
  <React.StrictMode>
    <Auth.Provider>
      <QueryClientProvider client={queryClient}>
        <QueryParams.Provider>
          <LoginGuard>
            <Router>
              <Suspense fallback={<span>LOADING</span>}>
                <App />
              </Suspense>
            </Router>
          </LoginGuard>
        </QueryParams.Provider>

        <ReactQueryDevtools initialIsOpen={true} />
      </QueryClientProvider>
    </Auth.Provider>
  </React.StrictMode>,
  $root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
